import useDidMount from './useDidMount';
import useDidUpdate from './useDidUpdate';
import useLiveRef from './useLiveRef';

const useUniqueEffect = (effect, deps) => {
    const effectRef = useLiveRef(effect);
    useDidMount(effectRef.current); 
	useDidUpdate(effectRef.current, [deps]);
};
export default useUniqueEffect;
